(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-old"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch('/cart/update.js', {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["megamenu"]) return;
  try {
    
  const colorElements = document.querySelectorAll(".megamenu_column__image__links p a");
  colorElements.forEach(element => {
    if (element.textContent.includes(" | ")) {
      const colorCode = element.textContent.split("|")[0].trim();
      element.innerHTML = '<span class="nav_link_color" style="background-color: ' + colorCode + '"></span>' + element.innerHTML.substr(colorCode.length + 2);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-group"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const tabLinks = document.querySelectorAll('.multicolumn-tab-link');

    tabLinks.forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();

        const targetId = link.dataset.targetColumnId;

        // Remove all active classes
        document.querySelectorAll('.multicolumn-tab-link').forEach(l => l.parentElement.classList.remove('active'));
        document.querySelectorAll('.column__card--group.active').forEach(c => {
          c.scrollTo({ left: 0, behavior: 'auto' });
          c.classList.remove('active');
        });

        // Activate the clicked tab and corresponding content
        link.parentElement.classList.add('active');
        link.parentElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        document.getElementById(targetId)?.classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            this.classList.add('product-recommendations--loaded');
            const { productsPerView } = this.dataset
            var yotpoSliderApi = new Yotpo.API(yotpo);
            yotpoSliderApi.refreshWidgets();
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
